import { format, isAfter, addYears } from 'date-fns';

export function registerFilters(app) {
    // apply filters
    app.config.globalProperties.$filters = {
        formatTimestamp(value, formatString = 'dd.MM.yyyy') {
            if (value) {
                const date = new Date(value);
                // check if the date is 50 years in the future
                if (isAfter(date, addYears(new Date(), 50))) {
                    return 'Never';
                }
                return format(date, formatString);
            }
        },
    };
}
